import { render, staticRenderFns } from "./locais.vue?vue&type=template&id=64e39411&"
import script from "./locais.vue?vue&type=script&lang=js&"
export * from "./locais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports